import Header from "../../components/header";
import LeftMenu from "../../components/left-menu";
import Grid from '@mui/material/Grid';
import "./style.css";
import React, {Component} from 'react';
import axios from "axios";
import { useState, useEffect } from 'react';
import TextField from '@mui/material/TextField'; 
import Button from '@mui/material/Button';
import {read} from "./api.js";
import {readEmpty} from "./apiEmpty.js";
import Post from "../../pages/ListKontrak/Post.jsx";
import {useNavigate} from "react-router-dom";
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import TableBody from '@mui/material/TableBody';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import CloseIcon from '@mui/icons-material/Close';
import EditIcon from '@mui/icons-material/Edit';
import ReceiptIcon from '@mui/icons-material/Receipt';
import LinearProgress from '@mui/material/LinearProgress';
import Box from '@mui/material/Box';
import { endOfDecadeWithOptions } from "date-fns/fp";
import { editableInputTypes } from "@testing-library/user-event/dist/utils";
import { Select, MenuItem } from '@mui/material';
import { purple } from '@mui/material/colors';
import { styled } from '@mui/material/styles';
import Signature from './Signature';
import { Typography } from "@mui/material";
import { useSelector } from 'react-redux';

export default function CreatePost(){

    
    const [Caption,setCaption] = useState("")
    const [skip, setSkip] = useState(0)
    const [posts, setPosts] = useState([])
    const [isEnd,setIsEnd] = useState("loading..")
    const navigate = useNavigate();
    const [query,setQuery] = useState("")
    const [previewVisibility, setPreviewVisibility] = useState(false)
    const [loadVisibility, setLoadVisibility] = useState(false)
    const [currPreview,setCurrPreview] = useState("none")
   

    useEffect(() => {
        fetchPosts();
        console.log(posts)
    }, [skip]);

    async function newKontrak(e){
        history("/create-kontrak",{state:{stuff:"new"}})
    }

    

    const fetchPosts = async () => {
        if(query.trim()){
                try{
                    const { data, error } = await read(skip,query,searchThis);
                    if(error){
                        
                        console.log(error.message);
                        return;
                    }
                    console.log(data.data)

                    if(data.data?.length === 0){
                        setIsEnd("Selesai...");
                        return;
                    }

                    const yoyo = data.data

                    //success
                    setPosts([...posts, ...yoyo])
                }catch(error){
                    console.log(error);
                }
            
        }else{

        try{
            const { data, error } = await readEmpty(skip,nowstate.user.sales);
            if(error){
                console.log(error.message);
                return;
            }
            if(data?.length === 0){
                setIsEnd("Selesai...");
                return;
            }
            
            //success
            setPosts([...posts, ...data])
        }catch(error){
            console.log(error.message);
        } 
        }
    }

    const [fileURL, setFileURL] = useState("");


    const previewPDF = async (post) => {
        console.log("diatas")
        setCurrPreview(post)
        setLoadVisibility(true)
        const id = post._id
        
        axios.post(`${process.env.REACT_APP_BACKEND_URL}/renderKontrakVOfromDB`,{
           id 
        }, {
            responseType: "blob"
          }).then(resp => {
                    console.log(resp)
                        const blob = new Blob([resp.data], { type: 'application/pdf' })
                    // saveAs(blob);
                    var fileURLNew = URL.createObjectURL(blob);
                    console.log(fileURLNew)
                    setPreviewVisibility(true)
                    setLoadVisibility(false)
                    setFileURL(fileURLNew)
                })
        
      
            

        
        console.log("2")
    
    }
    const nowstate = useSelector(state => state);

    const newFetchPosts = async (event) => {
        setPosts([])
        setIsEnd("Loading...");
        if(event.target.value.trim()){
        try{
            const { data, error } = await read(skip,event.target.value, searchThis);
            if(error){
                console.log(error.message);
                return;
            }

            if(data.data?.length === 0){
                setIsEnd("Selesai...");
                return;
            }
            const yoyo = data.data
            //success
            setPosts([...yoyo])
        }catch(error){
            console.log(error.message);
        }
        }else{
            console.log("empty")
            try{
                const { data, error } = await readEmpty(skip,nowstate.user.sales);
                if(error){
                    console.log(error.message);
                    return;
                }
    
                if(data?.length === 0){
                    setIsEnd("Selesai...");
                    return;
                }
                
                //success
                setPosts([...posts, ...data])
            }catch(error){
                console.log(error.message);
            } 
        }
    }
    const ColorButton = styled(Button)(({ theme }) => ({
        color: theme.palette.getContrastText(purple[500]),
        backgroundColor: purple[500],
        '&:hover': {
          backgroundColor: purple[700],
        },
      }));

    const handleScroll = (e) => {
        const { offsetHeight, scrollTop, scrollHeight } = e.target;

        if(offsetHeight + scrollTop >= scrollHeight){
            setSkip(posts?.length);
        }
    }
    const [searchThis, setsearchThis]= useState("KlienNama");
    const handleSearch = (event) =>{
        setQuery(event.target.value)
        setSkip(0)
        newFetchPosts(event)
    }

    const handleClosePreview = (event) =>{
        setPreviewVisibility(false)
        setCurrPreview("none")
    }
    const history = useNavigate();

    const editPI = async (post) => {
        if(currPreview === "none"){
            history("/create-kontrak",{state:{data:post, stuff:"edit"}})
        }else{
            history("/create-kontrak",{state:{data:currPreview, stuff:"edit"}})
        }
    }

    const extend = async (post)=>{
        if(currPreview === "none"){
            history("/create-kontrak", {state:{data:post,stuff:"extend"}})
        }else{
            history("/create-kontrak", {state:{data:currPreview,stuff:"extend"}})
        }
    }

    const [openSignature,setOpenSignature] = useState(false);
    const closeOpenSignature = () => {
        setOpenSignature(false)
    }

    const sudahKirim = () => {
        let message = "";
        switch (currPreview.CurrCategory) {
            case "R1":
              message = `*Reminder Extent Kontrak ${currPreview.TipeKontrak}*\n\nSelamat siang Bapak/Ibu, ini adalah pesan otomatis yang menginfokan bahwa kontrak bapak/ibu akan berakhir dalam ${currPreview.BerapaHari} hari lagi.`;
              break;
            case "R2":
                message = `*Dalam ${currPreview.BerapaHari} Hari* kontrak ${currPreview.TipeKontrak} bapak/ibu dengan nomor ${currPreview.kontrakNum} akan berakhir`;
                break;
            case "R3":
                message = `*Sebelum tanggal ${new Date(currPreview.TanggalBerakhir).toLocaleDateString('id-ID', {year: 'numeric', month: 'long', day: 'numeric'})}* harap proses perpanjangan kontrak Bapak/Ibu atau layanan yang diberikan akan berhenti`;
                break;
            case "R4":
                message = `Ini adalah pesan otomatis, Kontrak ${currPreview.kontrakNum} telah diberhentikan pada tanggal ${new Date(currPreview.TanggalBerakhir).toLocaleDateString('id-ID', {year: 'numeric', month: 'long', day: 'numeric'})}`;
                break;
            case "R5":
                message = `Kontrak ${currPreview.TipeKontrak} Bapak/Ibu dengan nomor ${currPreview.kontrakNum} *sudah berakhir* pada tanggal ${new Date(currPreview.TanggalBerakhir).toLocaleDateString('id-ID', {year: 'numeric', month: 'long', day: 'numeric'})}${(currPreview.TipeKontrak === 'Virtual Office') ? ', semua penerimaan paket dan telepon akan diberhentikan' : (currPreview.TipeKontrak === 'Call Center') ? ', semua penerimaan telepon akan diberhentikan' : (currPreview.TipeKontrak === 'Private Office') ? ', ruangan kantor Bapak/Ibu akan dibuka untuk tenant lainnya' : ''}.`;
                break;
            case "R6":
                message = ``;
                break;
            default:
              message = "Default Message";
          }
        
          // The phone number should include country code for international numbers, e.g., '+1234567890'
          const phoneNumber = currPreview.klienData.Phone[0];
        
          const url = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
        
          // Open a new window with the WhatsApp URL
          window.open(url, "_blank");
    }
    const [error, setError] = useState();
    const [responnya,setResponnya] = useState();
    const simpanRespon = () => {
        if(responnya){

            axios.post(`${process.env.REACT_APP_BACKEND_URL}/updateReminder`, {
                category: currPreview.CurrCategory, id:currPreview._id, respon:responnya
            }).then(() => {
                window.location.reload(); // refresh the page after successful update
            }).catch(error => {
                // handle error
                console.log(error);
            });
        }else{
            setError("Pilih Respon Klien")
        }
    }

    return <Grid container>
                <Dialog open={openSignature} onClose={closeOpenSignature}>
                    <Signature currPreview={currPreview} closeOpenSignature={closeOpenSignature}></Signature>
                </Dialog>
                <Dialog open={loadVisibility} aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    sx={{"& .MuiDialog-container": {
                        "& .MuiPaper-root": {
                        width: "100%",
                        maxWidth: "100px",  // Set your width here
                        },
                    },}}>
                    <DialogContent>
                    <Box sx={{ width: '100%' }}>
                        <LinearProgress />
                    </Box>
                    </DialogContent>
                </Dialog>
                <Grid xs={12} >
                <Dialog
                    open={previewVisibility}
                    onClose={handleClosePreview}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    sx={{"& .MuiDialog-container": {
                        "& .MuiPaper-root": {
                        width: "100%",
                        maxWidth: "1250px",  // Set your width here
                        },
                    },}}
                                >
                    <DialogTitle id="alert-dialog-title">
                        <Button onClick={handleClosePreview} autoFocus>
                            <CloseIcon></CloseIcon>
                        </Button>
                    </DialogTitle>
                    <DialogContent>
                    <Grid container>
                        <Grid xs={5}>
                            <iframe src={`${fileURL}#zoom=60`} width="100%" height="500" style={{zoom:"150%"}}/>
                        </Grid>
                        <Grid xs={1}></Grid>
                        <Grid xs={5}>
                            <Typography variant="h4">Data Kontrak</Typography>
                            <Grid xs={12} container>
                                <Grid item xs={4}>
                                    <Typography>Nama Perusahaan:</Typography>
                                </Grid>
                                <Grid item xs={8}>
                                    <Typography>{currPreview.CompanyName?? ""}</Typography>
                                </Grid>
                                <Grid item xs={4}>
                                    <Typography>Nama Klien:</Typography>
                                </Grid>
                                <Grid item xs={8}>
                                    <Typography>{currPreview.KlienNama?? ""}</Typography>
                                </Grid>
                                <Grid item xs={4}>
                                    <Typography>Expired:</Typography>
                                </Grid>
                                <Grid item xs={8}>
                                    <Typography>{new Date(currPreview.TanggalBerakhir).toLocaleDateString('id-ID', {
                                        year: 'numeric',
                                        month: 'long',
                                        day: 'numeric',
                                    })}</Typography>
                                </Grid>
                                <Grid item xs={4}>
                                    <Typography>Nomor:</Typography>
                                </Grid>
                                <Grid item xs={8}>
                                    <Typography>{currPreview.klienData?.Phone ? currPreview.klienData.Phone.join(', ') : 'No phone numbers available'}</Typography>
                                </Grid>
                             </Grid>
                            <Grid sx={{mt:3}} xs={12}>
                                <Typography>Sudah WA/info klien? Simpan respon mereka dibawah</Typography>
                                <Select  fullWidth value={responnya} onChange={event => setResponnya(event.target.value)}><MenuItem value="notResp">Belum di Respon</MenuItem><MenuItem value="Later">Baik akan diproses</MenuItem><MenuItem value="Stop">Tidak akan lanjut</MenuItem><MenuItem value="Done">Sudah Extent</MenuItem></Select>
                                {error && <Grid className="error_text" sx={{mb:3}}>{error}</Grid>}
                                <Button variant="contained" color="success" onClick={simpanRespon}>Simpan Respon Klien</Button>
                            </Grid>
                            <Grid sx={{mt:3}} xs={12}>
                                
                                <Button variant="contained" onClick={sudahKirim}>Kirim WA Template</Button>
                            </Grid>
                            <Grid sx={{mt:3}} xs={12}>
                            <Button variant="contained" color="error" onClick={handleClosePreview}>Tidak Jadi / Nanti Saja</Button>
                            </Grid>
                        </Grid>

                    </Grid>
                    <DialogContentText id="alert-dialog-description">
                    </DialogContentText>
                    </DialogContent>

                </Dialog>

                    <Grid>
                        
                           
                            <Grid container align = "center" justify = "center" alignItems = "center">
                            <Paper sx={{ width: '100%', overflow: 'hidden' }}>
                                <TableContainer sx={{ maxHeight: 250, minHeight: 250 }} className="min-h-screen h-screen overflow-scroll" onScroll={handleScroll}>
                                    <Table stickyHeader aria-label="sticky table">
                                        <TableHead>
                                            <TableRow>
                                                <TableCell style={{ width: 200 }}>
                                                    Extent Kontrak Reminder
                                                </TableCell>
                                            </TableRow>
                                        </TableHead>
                                        {posts?.map((post) => (
                                            <TableBody>
                                                <TableRow hover sx={{
            '&:hover': {
                backgroundColor: 'rgba(255, 83, 46,1) !important',
            },
            backgroundColor: 'red',
            height:"10px",
        }}>
                                                    <TableCell onClick={()=> previewPDF(post)} style={{cursor:'pointer',padding: '10px 16px', lineHeight: '1'}}>
                                                    <p>
                                                    {
                                                    post.CurrCategory === 'R1' ? 
                                                        <div>Kontrak {post.KlienNama} akan expired {post.BerapaHari} hari lagi</div> 
                                                    : post.CurrCategory === 'R2' ?
                                                        <div>Peringatan Kedua, kontrak {post.KlienNama} akan expired pada {new Date(post.TanggalBerakhir).toLocaleDateString('id-ID', {year: 'numeric', month: 'long', day: 'numeric'})}</div>
                                                    : post.CurrCategory === 'R3' ?
                                                        <div>Peringatan Ketiga, dalam 1-3 hari kedepan Kontrak {post.KlienNama} akan expired</div>
                                                    : post.CurrCategory === 'R4' ?
                                                        <div>Kontrak {post.KlienNama} sudah expired</div>
                                                    : post.CurrCategory === 'R5' ?
                                                        <div>Kontrak {post.KlienNama} sudah expired satu bulan lalu dan tidak akan ada penerimaan surat lagi</div>
                                                        : post.CurrCategory === 'R6' ?
                                                        <div>Ingatkan {post.KlienNama} salah satu kontraknya sudah tidak berlaku sama sekali</div>
                                                    :
                                                        <div>Kontrak {post.KlienNama} akan expired</div>
                                                    }
        </p>
                                                    </TableCell>
                                                </TableRow>
                                            </TableBody>
                                        ))}
                                        {isEnd}
                                    </Table>
                                </TableContainer>
                            </Paper>
                                
                            </Grid>
                            
                            
                    </Grid>
                </Grid>    
            </Grid>
    };